import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'companyName',
    title: 'Company Name',
    show: true,
    width: 417,
    valuesExport: ['companyName', 'companySize', 'country', 'website', 'status']
  },
  {
    isSortable: true,
    field: 'plan',
    title: 'Pricing Plan',
    show: true,
    width: 140,
    valuesExport: ['plan']
  },
  {
    isSortable: true,
    field: 'healthPoint',
    title: 'Health Score',
    fromToGroup: true,
    show: true,
    width: 182,
    valuesExport: ['healthStatus, healthPoint']
  },
  {
    isSortable: true,
    field: 'arr',
    title: 'ARR',
    fromToGroup: true,
    show: true,
    width: 88,
    valuesExport: ['arr']
  },
  {
    isSortable: true,
    field: 'npsScore',
    title: 'NPS',
    fromToGroup: true,
    show: true,
    width: 88,
    valuesExport: ['npsScore']
  },
  {
    isSortable: true,
    field: 'openTickets',
    title: 'Open Tickets',
    fromToGroup: true,
    show: true,
    width: 168,
    valuesExport: ['openTickets']
  },
  {
    isSortable: true,
    field: 'csatChatScore',
    title: 'CSAT Chat Score',
    fromToGroup: true,
    show: true,
    width: 198,
    valuesExport: ['csatChatScore']
  },
  {
    isSortable: true,
    field: 'csatTicketScore',
    title: 'CSAT Tickets Score',
    fromToGroup: true,
    show: true,
    width: 222,
    valuesExport: ['csatTicketScore']
  },
  {
    isSortable: true,
    field: 'csatTicketNum',
    title: 'CSAT Tickets No',
    fromToGroup: true,
    show: true,
    width: 198,
    valuesExport: ['csatTicketNum']
  },
  {
    isSortable: true,
    field: 'csatChatNum',
    title: 'CSAT Chats no',
    fromToGroup: true,
    show: true,
    width: 198,
    valuesExport: ['csatChatNum']
  },
  {
    isSortable: true,
    field: 'customerSuccessEngineer',
    title: 'CS Engineer',
    show: true,
    width: 158,
    valuesExport: ['customerSuccessEngineer']
  },
  {
    isSortable: true,
    field: 'accountManager',
    title: 'Acc. Manager',
    show: true,
    width: 158,
    valuesExport: ['accountManager']
  }
];

export const exportConfigSatisfactionBoard = {
  exportUrl: '/cs/satisfaction/export',
  exportName: 'satisfaction',
  exportFormat: 'zip'
};

export const defaultFilters = {
  companyName: '',
  status: ['Active'],
  companySize: [],
  customerType: [],
  plan: [],
  billingCycle: [],
  healthStatus: [],
  accountManager: [],
  customerSuccessEngineer: []
};

export const defaultNavigation = {
  fieldName: 'companyName',
  direction: initialTableShow.direction * -1,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage,
  healthPoint: {
    from: '',
    to: ''
  },
  arr: {
    from: '',
    to: ''
  },
  npsScore: {
    from: '',
    to: ''
  },
  openTickets: {
    from: '',
    to: ''
  },
  csatChatScore: {
    from: '',
    to: ''
  },
  csatTicketScore: {
    from: '',
    to: ''
  },
  csatChatNum: {
    from: '',
    to: ''
  },
  csatTicketNum: {
    from: '',
    to: ''
  }
};

export const chartColor = {
  Champion: '#4dc9f6',
  Healthy: '#6fcdcd',
  'Need Attention': '#fbdf9c',
  'At Risk': '#ff829d',
  'No Status': '#ac89f3'
};
